import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import distributionImg from '@/assets/distribution/distribution.png';
import icon01 from '@/assets/distribution/icon/icon-01-edit.png';
import icon02 from '@/assets/distribution/icon/icon-02-checklist.png';
import icon03 from '@/assets/distribution/icon/icon-03-upload.png';
import icon04 from '@/assets/distribution/icon/icon-04-growth.png';
import icon05 from '@/assets/distribution/icon/icon-05-finance.png';
import bottomBannerImg from '@/assets/distribution/bottom_banner.png';

export default function DistributionPage() {
  const scrollToWorkflow = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('workflow');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="distribution-page min-h-screen flex flex-col bg-[#f7fbf9]">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 pb-16 lg:pt-32 lg:pb-20 overflow-hidden bg-gradient-to-b from-[#eaf7f1] via-[#f3faf6] to-[#f7fbf9]">
        {/* 背景光晕装饰 */}
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-emerald-200/30 blur-[120px] rounded-full pointer-events-none" />

        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto relative z-10 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
            {/* Hero 左侧文字内容 */}
            <div className="lg:col-span-7 flex flex-col items-start text-left">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight tracking-tight mb-4">
                一站式<span className="text-[#00b96b]">海外短剧</span>发行服务 <br />
                让好内容被世界看见
              </h1>

              <p className="text-slate-600 text-base sm:text-lg leading-relaxed mb-8 max-w-2xl">
                覆盖海外TikTok与主流短剧APP，专业发行团队助力收益最大化
              </p>


              {/* 按钮 */}
              <div className="flex items-center">
                <Link
                  to="/apply"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-[#00b96b] hover:bg-[#00a35e] text-white text-base font-semibold shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/35 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 cursor-pointer"
                >
                  <span>立即发行</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </div>
            </div>

            {/* Hero 右侧插图 */}
            <div className="lg:col-span-5 relative flex items-center justify-center">
              <img
                src={distributionImg}
                alt="海外短剧发行服务"
                className="w-full max-w-[480px] lg:max-w-[520px] h-auto object-contain drop-shadow-xl hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 区块 1: 支持发行平台 */}
      <section className="py-16 sm:py-24 bg-white relative overflow-hidden">
        {/* 背景地图点阵微饰 */}
        <div className="absolute inset-0 flex items-center justify-center opacity-30 pointer-events-none">
          <svg className="w-full max-w-5xl h-full" viewBox="0 0 800 300" fill="none">
            <pattern id="dotGrid" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.5" className="fill-slate-300" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#dotGrid)" />
          </svg>
        </div>

        <div className="max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto relative z-10">
          {/* 标题 */}
          <div className="text-center mb-12 sm:mb-14">
            <h2 className="inline-flex items-center gap-2 text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              <span>支持发行的平台</span>
              <svg className="w-6 h-6 text-amber-400 fill-amber-400" viewBox="0 0 24 24">
                <path d="M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4L12 2z" />
              </svg>
            </h2>
            <p className="text-slate-500 text-sm sm:text-base mt-2">
              覆盖主流海外短视频与短剧平台
            </p>
          </div>

          {/* 两列平台卡片 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* 卡片 1: 海外 TikTok */}
            <div className="bg-[#f0fdf4] border border-emerald-100/80 rounded-3xl p-6 sm:p-8 flex flex-col justify-between shadow-xs hover:shadow-lg hover:border-emerald-200 transition-all duration-300">
              <div>
                {/* 头部：Logo + 标题与副标题 */}
                <div className="flex items-start gap-4 mb-6">
                  {/* TikTok Icon */}
                  <div className="w-14 h-14 sm:w-16 sm:h-16 shrink-0 rounded-2xl bg-black flex items-center justify-center shadow-md shadow-black/10">
                    <svg className="w-8 h-8 sm:w-9 sm:h-9" viewBox="0 0 24 24" fill="white">
                      <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 2.22A6.34 6.34 0 0 0 3.75 15.67a6.342 6.342 0 0 0 10.857 4.472 6.29 6.29 0 0 0 1.744-4.472V8.406a8.232 8.232 0 0 0 4.788 1.524V6.485a4.785 4.785 0 0 1-1.55-.2 4.764 4.764 0 0 1-.001.401z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-bold text-[#16a34a] mb-1">海外 TikTok</h3>
                    <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                      覆盖全球多个国家和地区，触达亿万用户
                    </p>
                  </div>
                </div>

                {/* 勾选列表 */}
                <div className="space-y-3.5 mb-8">
                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#16a34a] text-white flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700 text-sm font-medium">短剧内容挂载与推广</span>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#16a34a] text-white flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700 text-sm font-medium">精准用户触达与投放</span>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#16a34a] text-white flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700 text-sm font-medium">数据分析与优化支持</span>
                  </div>
                </div>
              </div>

            </div>

            {/* 卡片 2: 海外短剧 APP */}
            <div className="bg-[#fff7ed] border border-amber-100/80 rounded-3xl p-6 sm:p-8 flex flex-col justify-between shadow-xs hover:shadow-lg hover:border-amber-200 transition-all duration-300">
              <div>
                {/* 头部：Logo + 标题与副标题 */}
                <div className="flex items-start gap-4 mb-6">
                  {/* 短剧 APP Icon */}
                  <div className="w-14 h-14 sm:w-16 sm:h-16 shrink-0 rounded-2xl bg-gradient-to-br from-[#ff6a3b] to-[#ff3b30] flex items-center justify-center shadow-md shadow-orange-500/20">
                    <div className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center">
                      <svg className="w-4 h-4 fill-white translate-x-0.5" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-bold text-slate-900 mb-1">海外短剧 APP</h3>
                    <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                      接入主流海外短剧应用，精准触达短剧用户
                    </p>
                  </div>
                </div>

                {/* 勾选列表 */}
                <div className="space-y-3.5 mb-8">
                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#f97316] text-white flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700 text-sm font-medium">多平台分发与上线</span>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#f97316] text-white flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700 text-sm font-medium">本地化运营与推广</span>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#f97316] text-white flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-700 text-sm font-medium">收益监控与优化</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* 区块 3: 发行流程 */}
      <section id="workflow" className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto">
          {/* 标题 */}
          <div className="text-center mb-16">
            <h2 className="inline-flex items-center gap-2 text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              <svg className="w-6 h-6 text-amber-400 fill-amber-400" viewBox="0 0 24 24">
                <path d="M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4L12 2z" />
              </svg>
              <span>发行流程</span>
            </h2>
            <p className="text-slate-500 text-sm sm:text-base mt-2">
              简单高效的发行流程，让您的内容快速出海
            </p>
          </div>

          {/* 5步流程容器 */}
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-4 relative items-start">
              {/* 步骤 1 */}
              <div className="flex flex-col items-center text-center group relative z-10">
                <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white shadow-xs border border-gray-100 flex items-center justify-center p-5 mb-4 group-hover:scale-105 group-hover:shadow-md transition-all duration-300">
                  <img src={icon01} alt="提交短剧" className="w-full h-full object-contain" />
                </div>
                <div className="flex items-center justify-center gap-1.5 mb-1.5">
                  <span className="w-5 h-5 rounded-full bg-[#16a34a] text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                    01
                  </span>
                  <h4 className="text-base font-bold text-slate-900">提交短剧</h4>
                </div>
                <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                  提交短剧内容与发行需求
                </p>
              </div>

              {/* 连接箭头 1-2 */}
              <div className="hidden lg:flex absolute top-12 left-[16%] w-[8%] items-center justify-center text-emerald-400/80 pointer-events-none">
                <svg className="w-full h-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" viewBox="0 0 40 12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M0 6h32m-4-4l4 4-4 4" />
                </svg>
              </div>

              {/* 步骤 2 */}
              <div className="flex flex-col items-center text-center group relative z-10">
                <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white shadow-xs border border-gray-100 flex items-center justify-center p-5 mb-4 group-hover:scale-105 group-hover:shadow-md transition-all duration-300">
                  <img src={icon02} alt="内容审核" className="w-full h-full object-contain" />
                </div>
                <div className="flex items-center justify-center gap-1.5 mb-1.5">
                  <span className="w-5 h-5 rounded-full bg-[#16a34a] text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                    02
                  </span>
                  <h4 className="text-base font-bold text-slate-900">内容审核</h4>
                </div>
                <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                  专业团队审核与优化建议
                </p>
              </div>

              {/* 连接箭头 2-3 */}
              <div className="hidden lg:flex absolute top-12 left-[36%] w-[8%] items-center justify-center text-emerald-400/80 pointer-events-none">
                <svg className="w-full h-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" viewBox="0 0 40 12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M0 6h32m-4-4l4 4-4 4" />
                </svg>
              </div>

              {/* 步骤 3 */}
              <div className="flex flex-col items-center text-center group relative z-10">
                <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white shadow-xs border border-gray-100 flex items-center justify-center p-5 mb-4 group-hover:scale-105 group-hover:shadow-md transition-all duration-300">
                  <img src={icon03} alt="平台上线" className="w-full h-full object-contain" />
                </div>
                <div className="flex items-center justify-center gap-1.5 mb-1.5">
                  <span className="w-5 h-5 rounded-full bg-[#16a34a] text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                    03
                  </span>
                  <h4 className="text-base font-bold text-slate-900">平台上线</h4>
                </div>
                <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                  分发至海外主流平台
                </p>
              </div>

              {/* 连接箭头 3-4 */}
              <div className="hidden lg:flex absolute top-12 left-[56%] w-[8%] items-center justify-center text-emerald-400/80 pointer-events-none">
                <svg className="w-full h-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" viewBox="0 0 40 12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M0 6h32m-4-4l4 4-4 4" />
                </svg>
              </div>

              {/* 步骤 4 */}
              <div className="flex flex-col items-center text-center group relative z-10">
                <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white shadow-xs border border-gray-100 flex items-center justify-center p-5 mb-4 group-hover:scale-105 group-hover:shadow-md transition-all duration-300">
                  <img src={icon04} alt="运营推广" className="w-full h-full object-contain" />
                </div>
                <div className="flex items-center justify-center gap-1.5 mb-1.5">
                  <span className="w-5 h-5 rounded-full bg-[#16a34a] text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                    04
                  </span>
                  <h4 className="text-base font-bold text-slate-900">运营推广</h4>
                </div>
                <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                  精准投放与本地化运营
                </p>
              </div>

              {/* 连接箭头 4-5 */}
              <div className="hidden lg:flex absolute top-12 left-[76%] w-[8%] items-center justify-center text-emerald-400/80 pointer-events-none">
                <svg className="w-full h-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 3" viewBox="0 0 40 12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M0 6h32m-4-4l4 4-4 4" />
                </svg>
              </div>

              {/* 步骤 5 */}
              <div className="flex flex-col items-center text-center group relative z-10">
                <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white shadow-xs border border-gray-100 flex items-center justify-center p-5 mb-4 group-hover:scale-105 group-hover:shadow-md transition-all duration-300">
                  <img src={icon05} alt="收益分成" className="w-full h-full object-contain" />
                </div>
                <div className="flex items-center justify-center gap-1.5 mb-1.5">
                  <span className="w-5 h-5 rounded-full bg-[#16a34a] text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                    05
                  </span>
                  <h4 className="text-base font-bold text-slate-900">收益分成</h4>
                </div>
                <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">
                  收益统计与分成结算
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 底部 CTA 区域 */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto">
          <div
            className="relative rounded-[28px] overflow-hidden shadow-sm aspect-[2389/705] w-full flex items-end px-6 sm:px-10 lg:px-14 pb-4 sm:pb-6 lg:pb-7"
            style={{ aspectRatio: '2389 / 705' }}
          >
            {/* 背景图 (图片本身已自带背景与文案，等比例铺满) */}
            <img
              src={bottomBannerImg}
              alt="让您的短剧走向世界"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />

            {/* 按钮区域 */}
            <div className="relative z-10 flex flex-wrap items-center gap-3 sm:gap-4">
              <Link
                to="/apply"
                className="inline-flex items-center justify-center px-6 sm:px-7 py-2.5 sm:py-3 rounded-full bg-[#16a34a] hover:bg-[#15803d] text-white text-xs sm:text-sm font-semibold shadow-md shadow-emerald-600/20 hover:shadow-emerald-600/30 transition-all duration-200 cursor-pointer"
              >
                立即提交短剧
              </Link>

              <Link
                to="/apply"
                className="inline-flex items-center justify-center px-7 sm:px-8 py-2.5 sm:py-3 rounded-full bg-white hover:bg-gray-50 text-slate-800 text-xs sm:text-sm font-semibold shadow-sm hover:shadow-md border border-gray-100 transition-all duration-200 cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

